module.exports = __webpack_public_path__ + "a48908a6b4b3a2943d390ec8efa074ad.pdf";